import { httpRequest } from '@calendly/http-tools'

import {
  stripeClientSecretError,
  stripeClientSecretFetched,
  stripeClientSecretPending
} from '../../../actions/payment'

const MAX_RETRIES = 3
const RETRY_DELAY_MS = 1000

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const isServerError = (response) => {
  const status = response?.status
  return typeof status === 'number' && status >= 500 && status < 600
}

const fetchWithRetries = async (packageUuid, dispatch, attempt) => {
  const [ok, res] = await httpRequest({
    url: `/api/booking/packages/${packageUuid}/stripe_payment_intents`,
    method: 'POST'
  })

  if (ok) {
    dispatch(stripeClientSecretFetched(res.resource.client_secret, res.resource.stripe_account))
    return
  }

  if (!isServerError(res) || attempt === MAX_RETRIES) {
    console.warn('[PackageStripeContainer] Payment form initialization failed after retries', {
      packageUuid,
      status: res?.status
    })
    dispatch(stripeClientSecretError())
    return
  }

  await delay(RETRY_DELAY_MS)
  await fetchWithRetries(packageUuid, dispatch, attempt + 1)
}

export const fetchPackageClientSecret = (packageUuid) => async (dispatch, getState) => {
  const state = getState()
  const { status } = state.scheduling.stripeClientSecret

  if (!['ready', 'error'].includes(status) || !packageUuid) return

  dispatch(stripeClientSecretPending())

  await fetchWithRetries(packageUuid, dispatch, 1)
}
